import { 
  useGridSelector,
  gridFilteredDescendantCountLookupSelector,
  GridRenderCellParams,
  GridGroupNode,
  useGridRootProps,
  useGridApiContext, } from "@mui/x-data-grid-pro";
import { vars } from '@mui/x-data-grid/internals';
interface GridTreeDataGroupingCellProps
  extends GridRenderCellParams<any, any, any, GridGroupNode> {}

export const GroupingColumn = (props: GridTreeDataGroupingCellProps) => {
  const { id, field, rowNode } = props;

  const rootProps = useGridRootProps();
  const apiRef = useGridApiContext();
  const filteredDescendantCountLookup = useGridSelector(
    apiRef,
    gridFilteredDescendantCountLookupSelector,
  );

  const filteredDescendantCount = filteredDescendantCountLookup[rowNode.id] ?? 0;

  const handleClick = () => {
    apiRef.current.setRowChildrenExpansion(id, !rowNode.childrenExpanded);
    apiRef.current.setCellFocus(id, field);
  };
  
  const Icon = rowNode.childrenExpanded
  ? rootProps.slots.treeDataCollapseIcon
  : rootProps.slots.treeDataExpandIcon;

  return (
    <div
    style={{
      marginLeft: vars.spacing(rowNode.depth * 2),
      display: 'flex',
      alignItems: 'center'
    }}
   
  >
    <div>
      {filteredDescendantCount > 0 && (
        <rootProps.slots.baseIconButton
          size="small"
          onClick={handleClick}
          tabIndex={-1}
          aria-label={
            rowNode.childrenExpanded
              ? apiRef.current.getLocaleText('treeDataCollapse')
              : apiRef.current.getLocaleText('treeDataExpand')
          }
          {...rootProps?.slotProps?.baseIconButton}
        >
          <Icon fontSize="inherit" />
        </rootProps.slots.baseIconButton>
      )}
    </div>

  </div>
  );
};